'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bKeycodes = (require('./../../keycodes/keycodes.react.js').default || require('./../../keycodes/keycodes.react.js')).applyDecls();

var _bKeycodes2 = _interopRequireDefault(_bKeycodes);

var _iBem = require('../../i-bem/i-bem.react');

var _eInner = (require('./../__inner/link__inner.react.js').default || require('./../__inner/link__inner.react.js')).applyDecls();

var _eInner2 = _interopRequireDefault(_eInner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: Вернуть {pseudo: true} после https://st.yandex-team.ru/ISL-4039
exports.default = (0, _iBem.declMod)(function (props) {
    return Object(props).pseudo;
}, {
    block: 'link',
    willInit: function willInit(_ref) {
        var tabIndex = _ref.tabIndex;

        this.__base.apply(this, arguments);

        this.onClick = this.onClick.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
    },
    mods: function mods() {
        var pressed = this.state.pressed;

        return _extends({}, this.__base.apply(this, arguments), {
            pressed: pressed
        });
    },
    attrs: function attrs() {
        var disabled = this.state.disabled;

        return _extends({}, this.__base.apply(this, arguments), {
            onClick: disabled ? undefined : this.onClick
        });
    },
    content: function content(_ref2) {
        var inner = _ref2.inner;

        var content = this.__base.apply(this, arguments);
        if (!inner) {
            return _react2.default.createElement(
                _eInner2.default,
                { key: 'inner' },
                content
            );
        }

        return content;
    },
    onClick: function onClick(e) {
        e.preventDefault();

        this.props.onClick && this.props.onClick(e);
    },
    onKeyDown: function onKeyDown(e) {
        if (_bKeycodes2.default.is(e.which, 'ENTER', 'SPACE')) {
            if (e.which === _bKeycodes2.default.SPACE) {
                e.preventDefault(); // Отменяем scroll.
            }

            this.setState({ pressed: true });
        }
    },
    onKeyUp: function onKeyUp(e) {
        if (_bKeycodes2.default.is(e.which, 'ENTER', 'SPACE')) {
            this.setState({ pressed: false });
        }
    }
}, {
    propTypes: {
        inner: _propTypes2.default.bool
    }
});